import { localPublicAssetUrl } from '../../../utils/localPublicAssetUrl'

export { localPublicAssetUrl }

/** Vercel Blob root for PvP UI (`pvp/…` on CDN). */
export const ONLINE_PVP_ASSET_BASE_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/pvp'

/** Vercel Blob root for ranked/unranked lobby update art (`update-pvp/…` on CDN). */
export const ONLINE_UPDATE_PVP_ASSET_BASE_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/update-pvp'

/**
 * Hub lobby + direct-challenge art that also exist under `public/assets/images/pvp/`.
 * Switch source here to flip every `pvpHubAssetUrl` call without editing components.
 */
export type PvpHubAssetSource = 'local' | 'online'

/** `'local'` → CRA `public/assets/images/pvp/` · `'online'` → Blob `ONLINE_PVP_ASSET_BASE_URL` */
export const PVP_HUB_ASSET_SOURCE: PvpHubAssetSource = 'online'

/** Single file name (e.g. `bg.webp`) under the Blob `pvp/` folder. */
export function onlinePvpAssetUrl(fileName: string): string {
  const f = fileName.replace(/^\//, '')
  return `${ONLINE_PVP_ASSET_BASE_URL}/${f}`
}

/** Single file name (e.g. `waiting-vs.webp`) under the Blob `update-pvp/` folder. */
export function updatePvpAssetUrl(fileName: string): string {
  const f = fileName.replace(/^\//, '')
  return `${ONLINE_UPDATE_PVP_ASSET_BASE_URL}/${f}`
}

/**
 * Lobby / direct-challenge images that live in both `public/assets/images/pvp/` and Blob.
 * Toggle {@link PVP_HUB_ASSET_SOURCE} to switch all usages at once.
 */
export function pvpHubAssetUrl(fileName: string): string {
  const f = fileName.replace(/^\//, '')
  if (PVP_HUB_ASSET_SOURCE === 'local') {
    return localPublicAssetUrl(`/assets/images/pvp/${f}`)
  }
  return onlinePvpAssetUrl(f)
}

/** File under Blob `pvp/direct-challenge/` (mirrors `public/assets/images/pvp/direct-challenge/`). */
export function pvpDirectChallengeAssetUrl(fileName: string): string {
  const f = fileName.replace(/^\//, '')
  return onlinePvpAssetUrl(`direct-challenge/${f}`)
}

/** Prefetched with {@link startPvpAssetWarmup} deferred batch (send + ranked MMR icons are in lobby warmup). */
export const PVP_DIRECT_CHALLENGE_WARMUP_URLS: readonly string[] = [
  pvpDirectChallengeAssetUrl('border-horizontal-texture.webp'),
  pvpDirectChallengeAssetUrl('cornor-top-left-texture.webp'),
  pvpDirectChallengeAssetUrl('noMMRChange.webp'),
  pvpDirectChallengeAssetUrl('noStakePayout.webp'),
  pvpDirectChallengeAssetUrl('playForFunAndPractice.webp'),
  pvpDirectChallengeAssetUrl('vs-mark.webp'),
  pvpDirectChallengeAssetUrl('alert-mark.webp'),
  pvpDirectChallengeAssetUrl('opponentPower.webp'),
  pvpDirectChallengeAssetUrl('yourPower.webp'),
  pvpDirectChallengeAssetUrl('powerDifference.webp'),
  pvpDirectChallengeAssetUrl('rankedPowerDifference.webp'),
  pvpDirectChallengeAssetUrl('rankedPayut.webp'),
]
